import React, { useState, useEffect } from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import circleSwapLoader from '../../assets/Loading/Circle Swap Loading.lottie';
import './LoadingScreen.css';

const LoadingScreen = ({ isOpen, delay = 250, fullScreen = false }) => {
  const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    let timer;
    if (isOpen) {
      timer = setTimeout(() => {
        setShouldShow(true);
      }, delay);
    } else {
      setShouldShow(false);
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [isOpen, delay]);

  if (!shouldShow || !isOpen) return null;

  return (
    <div className={`loading-overlay ${fullScreen ? 'full-screen' : ''}`}>
      <div className="loading-animation-wrapper">
        <DotLottieReact
          src={circleSwapLoader}
          autoplay
          loop
        />
      </div>
    </div>
  );
};

export default LoadingScreen;
